module.exports = __webpack_public_path__ + "static/media/bootstrap.a0de09d8.png";